module.exports = __webpack_public_path__ + "static/media/bellpeppers.f21d261a.webp";